"use strict";
var Observable_1 = require('../../Observable');
var audit_1 = require('../../operator/audit');
Observable_1.Observable.prototype.audit = audit_1.audit;
//# sourceMappingURL=audit.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/rxjs/add/operator/audit.js
 ** module id = 772
 ** module chunks = 0
 **/